import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../i18n";
import { AlertCircle, Sparkles, Clock, Lock } from "lucide-react";

/**
 * Banner shown when subscription is in trial, grace, read_only or cancelled.
 * Hidden when status is "active".
 */
export default function SubscriptionBanner() {
  const { subscription, user } = useAuth();
  const { t } = useI18n();

  if (!subscription) return null;
  const eff = subscription.effective_status;
  if (eff === "active") return null;

  const isOwner = user?.role === "owner";
  const daysRemaining = subscription.days_remaining;

  const STYLES = {
    trial: { bg: "bg-[#2563eb]/10", border: "border-[#2563eb]/40", fg: "text-[#1e40af]", icon: Sparkles, label: t("billing.bannerTrial") },
    grace: { bg: "bg-[#e3a03b]/15", border: "border-[#e3a03b]/50", fg: "text-[#8a5a10]", icon: Clock, label: t("billing.bannerGrace") },
    read_only: { bg: "bg-[#d34044]/10", border: "border-[#d34044]/40", fg: "text-[#b12e31]", icon: Lock, label: t("billing.bannerReadOnly") },
    cancelled: { bg: "bg-[#d34044]/10", border: "border-[#d34044]/40", fg: "text-[#b12e31]", icon: AlertCircle, label: t("billing.bannerCancelled") },
  };
  const cfg = STYLES[eff] || STYLES.grace;
  const Icon = cfg.icon;

  return (
    <div
      data-testid="subscription-banner"
      className={`mb-6 rounded-2xl border ${cfg.border} ${cfg.bg} p-4 flex items-center gap-3`}
    >
      <Icon className={`w-5 h-5 ${cfg.fg} shrink-0`} />
      <div className={`flex-1 text-sm font-semibold ${cfg.fg}`}>
        <span>{cfg.label}</span>
        {daysRemaining > 0 && <span className="ml-2 font-normal opacity-80">· {daysRemaining} {t("billing.daysRemaining").toLowerCase()}</span>}
      </div>
      {isOwner && (
        <Link
          to="/app/billing"
          data-testid="banner-renew"
          className="px-4 py-2 rounded-xl bg-brand hover:bg-brand-hover text-white text-sm font-heading font-bold transition-colors whitespace-nowrap"
        >
          {t("billing.renew")}
        </Link>
      )}
    </div>
  );
}
